// src/services/usuarioService.js

const API_URL = `${process.env.REACT_APP_API_URL}/usuarios`;

export const crearUsuario = async (datos, token) => {
  try {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datos),
    });
    return await res.json();
  } catch (err) {
    return { mensaje: 'Error de conexión al crear usuario' };
  }
};
